export default {
  // FireStoreから取得した拠点情報
  equipmentBaseStations: [],
  // FireStoreから取得した資機材船舶情報
  equipmentVessels: [],
  // FireStoreから取得した投入実績情報
  equipmentTypes: [],
  // FireStoreから取得した資機材カテゴリマスタ
  equipmentCategories: [],
  // FireStoreから取得した出発岸壁マスタ
  equipmentDepartureWharfs: [],
  // FireStoreから取得した目的地マスタ
  equipmentDestinations: [],
  // FireStoreから取得した運搬航路マスタ
  equipmentSeaRoutes: [],
};
